import { View } from "binder"
import { FileSelectorViewModel } from "uicomponents";
import { IbanPaymentViewModel } from "./ibanPayment-viewModel"
import { IbanSelectorSelectorViewModel } from "./ibanSelector-viewModel";

export class IbanPaymentView extends View<IbanPaymentViewModel>{
    GetViewUniqueId(): string {
        return "V-5054F6D2-A5FD-4B45-9379-47BEDB0962E8"
    }
    loadHtml(): string {
        let element = require('./ibanPayment.html').default;
        let style = require('./ibanPayment.less');
        return element;
    }
    constructor() {
       super();
    } 
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set ibanSelectorViewModel(v: IbanSelectorSelectorViewModel) { this._ibanSelectorViewModel = v; } public get ibanSelectorViewModel(): IbanSelectorSelectorViewModel { return this._ibanSelectorViewModel;} private _ibanSelectorViewModel: IbanSelectorSelectorViewModel;
    public set maxAmount(v: number) { this._maxAmount = v; } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    public set paymentTime(v: moment.Moment) { this._paymentTime = v; } public get paymentTime(): moment.Moment { return this._paymentTime;} private _paymentTime: moment.Moment;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
}
